/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AutomaticGainControlChannelFragment = {
	id: string;
	description: {
		group: Types.AudioChannelGroup;
		constraints: {
			automaticGainControl: {
				maxBoost: { range: { min: number; max: number; step: number } };
				maxCut: { range: { min: number; max: number; step: number } };
				targetLevel: { range: { min: number; max: number; step: number } };
			} | null;
			automaticGain: { gain: { range: { min: number; max: number; step: number } } } | null;
		};
		features: {
			channelConfiguration: { supported: boolean };
			automaticGainControlPeak: { supported: boolean };
			automaticGainControlRms: { supported: boolean };
		};
	};
	features: {
		name: { name: string } | null;
		automaticGainControl: { enabled: boolean; targetLevel: number; maxBoost: number; maxCut: number } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
};

export type AutomaticGainControlChannelUpdateFragment = {
	id: string;
	features:
		| { automaticGainControl: { enabled: boolean; targetLevel: number; maxBoost: number; maxCut: number } | null }
		| { channelConfiguration: { enabled: boolean } | null }
		| { name: { name: string } | null }
		| {};
};

export type AutomaticGainControlChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type AutomaticGainControlChannelQueryOpResult = { node: AutomaticGainControlChannelFragment | {} };

export type AutomaticGainControlChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type AutomaticGainControlChannelSubscriptionOpResult = {
	nodeChanges: AutomaticGainControlChannelFragment | AutomaticGainControlChannelUpdateFragment | {};
};

export type AutomaticGainControlChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type AutomaticGainControlChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export const AutomaticGainControlChannelFragment = gql`
	fragment AutomaticGainControlChannelFragment on AudioChannel {
		id
		description {
			group
			constraints {
				automaticGainControl {
					maxBoost {
						range {
							min
							max
							step
						}
					}
					maxCut {
						range {
							min
							max
							step
						}
					}
					targetLevel {
						range {
							min
							max
							step
						}
					}
				}
				automaticGain {
					gain {
						range {
							min
							max
							step
						}
					}
				}
			}
			features {
				channelConfiguration {
					supported
				}
				automaticGainControlPeak {
					supported
				}
				automaticGainControlRms {
					supported
				}
			}
		}
		features {
			name {
				name
			}
			automaticGainControl {
				enabled
				targetLevel
				maxBoost
				maxCut
			}
			channelConfiguration {
				enabled
			}
		}
	}
`;
export const AutomaticGainControlChannelUpdateFragment = gql`
	fragment AutomaticGainControlChannelUpdateFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelAutomaticGainControlChange {
				automaticGainControl {
					enabled
					targetLevel
					maxBoost
					maxCut
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
		}
	}
`;
export const AutomaticGainControlChannelQueryDocument = gql`
	query AutomaticGainControlChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...AutomaticGainControlChannelFragment
		}
	}
	${AutomaticGainControlChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AutomaticGainControlChannelQueryGQL extends Apollo.Query<
	AutomaticGainControlChannelQueryOpResult,
	AutomaticGainControlChannelQueryVariables
> {
	override document = AutomaticGainControlChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AutomaticGainControlChannelSubscriptionDocument = gql`
	subscription AutomaticGainControlChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on AudioChannel {
				...AutomaticGainControlChannelFragment
			}
			... on AudioChannelChange {
				...AutomaticGainControlChannelUpdateFragment
			}
		}
	}
	${AutomaticGainControlChannelFragment}
	${AutomaticGainControlChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AutomaticGainControlChannelSubscriptionGQL extends Apollo.Subscription<
	AutomaticGainControlChannelSubscriptionOpResult,
	AutomaticGainControlChannelSubscriptionVariables
> {
	override document = AutomaticGainControlChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AutomaticGainControlChannelMutationDocument = gql`
	mutation AutomaticGainControlChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class AutomaticGainControlChannelMutationGQL extends Apollo.Mutation<
	AutomaticGainControlChannelMutationOpResult,
	AutomaticGainControlChannelMutationVariables
> {
	override document = AutomaticGainControlChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
